module.exports = __webpack_public_path__ + "static/img/service_introduce_5876_zh_h5.a583dd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_5876_zh_h5.png
// module id = SAa3
// module chunks = 34